import React, { useEffect, useRef } from "react";
import JSConfetti from "js-confetti";


export default function useConfetti() {
  const jsConfetti = useRef<JSConfetti | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const JSConfetti = require("js-confetti").default;
      jsConfetti.current = new JSConfetti();
    }
  }, []);

  const popConfetti = () => {
    if (jsConfetti.current) {
      jsConfetti.current.addConfetti();
    }
  };

  return popConfetti;
}

